/* @ngInject */

export default (CompareProductSplit, dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function SwitchCompareProduct(id, productSplits, switchTimeStamp, isActive) {
    this.id = id;
    this.productSplits = productSplits;
    this.switchTimeStamp = switchTimeStamp;
    this.isActive = isActive;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  SwitchCompareProduct.Blank = function () {
    return SwitchCompareProduct.Build({
      id: _.uuid(),
      productSplits: [],
      switchTimeStamp: dateTimeService.epoch(),
      isActive: true
    });
  };
  SwitchCompareProduct.Build = function (data) {
    return new SwitchCompareProduct(
      data?.id || _.uuid(),
      _.map(_.compact(data?.productSplits), (productSplit) =>
        CompareProductSplit.Build(productSplit)
      ),
      data?.switchTimeStamp ? parseInt(data.switchTimeStamp || 0, 10) : dateTimeService.epoch(),
      data?.isActive === true
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  SwitchCompareProduct.prototype.getSwitchedDate = function (timeZone, format) {
    return moment
      .utc(this.switchTimeStamp, 'X')
      .tz(timeZone || 'UTC')
      .format(format || 'LL');
  };

  return SwitchCompareProduct;
};
